export default {
	OPERATOR_EQUALS: 'Equals',
	OPERATOR_NOT_EQUAL: 'Not equals',
	OPERATOR_LIKE: 'Like',
	OPERATOR_NOT_LIKE: 'Not like',
	OPERATOR_GREATER: 'Greater',
	OPERATOR_GREATER_EQUAL: 'Greater or equal',
	OPERATOR_SMALLER: 'Smaller',
	OPERATOR_SMALLER_EQUAL: 'Smaller or equal',
	OPERATOR_RANGE: 'Between',
	OPERATOR_IN: 'In',
	OPERATOR_NOT_IN: 'Not In',
	OPERATOR_IS_NULL: 'Is blank',
	OPERATOR_IS_NOT_NULL: 'Is not blank',

	OPERATOR_BOOL_ALL: 'All',
	OPERATOR_BOOL_TRUE: 'True',
	OPERATOR_BOOL_FALSE: 'False',

	QB_ADD_GROUP: 'Group',
	QB_ADD_RULE: 'Rule',
	QB_DEL_GROUP: 'Remove',
	QB_TEXT_SEPARATOR_AND: 'and'
};
